/* Route Paths */
const mountPath = window.frameworkGlobals.mountPath;

export const ROUTES_PREFIX = {
  PUBLIC: `${mountPath}`,
};

export const API_ROUTE_PATHS = {
  PREFIX_URL: `${mountPath}/api`,
};
